import { useState } from 'react';
import SideModal from '~/components/SideModal';
import WarningModal from '~/routes/User/AddInvoice/WarningModal';
import AddClient from '.';
import Portal from '~/components/Portal';

interface IAddClientModalProps {
  isModalOpen: boolean;
  onCloseClientModal(): void;
  heading?: string;
  clientId?: string | null;
  onClientCreated?: (client: any) => void;
}

const AddClientModal = ({
  isModalOpen,
  onCloseClientModal,
  heading = 'Add New Client',
  clientId = null,
  onClientCreated,
}: IAddClientModalProps) => {
  const [showWarningModal, setShowWarningModal] = useState(false);

  const handleCloseAttempt = () => {
    setShowWarningModal(true);
  };

  const handleConfirmClose = () => {
    setShowWarningModal(false);
    onCloseClientModal();
  };

  const handleCancelClose = () => {
    setShowWarningModal(false);
  };

  return (
    <Portal>
      <SideModal
        size="sm"
        isOpen={isModalOpen}
        onClose={handleCloseAttempt}
        children={
          <AddClient
            businessClientUuid={clientId}
            onClose={onCloseClientModal}
            onClientCreated={onClientCreated}
          />
        }
        heading={{ text: heading }}
      />

      <WarningModal
        isVisible={showWarningModal}
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
        title="Discard changes?"
        message="Are you sure you want to leave? Your unsaved changes will be lost and cannot be recovered."
        confirmText="Discard"
        cancelText="Cancel"
      />
    </Portal>
  );
};

export default AddClientModal;
